import type {
  DedicatedServiceWorkersGetApiData,
  DedicatedServiceWorkersGetApiResponses,
  DedicatedServiceWorkersPatchApiData,
  DedicatedServiceWorkersPatchApiResponses,
  PaymentOptionsGetApiData,
  PaymentOptionsGetApiResponses,
  PaymentOptionsPatchApiData,
  PaymentOptionsPatchApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

// Settings a customer has at one service organization (UserGroupServiceOrganization).
export const serviceOrganizationLinkUrls = {
  getPaymentOptions: dataEndpoint<PaymentOptionsGetApiData, PaymentOptionsGetApiResponses>({
    getUrl: ({ userGroupId, serviceOrganizationId, ...queryParams }) =>
      apiUrl(`user-groups/${userGroupId}/service-organizations/${serviceOrganizationId}/payment-options/`, queryParams)
  }),
  patchPaymentOptions: responseEndpoint<PaymentOptionsPatchApiData, PaymentOptionsPatchApiResponses>({
    getUrl: ({ userGroupId, serviceOrganizationId }) =>
      apiUrl(`user-groups/${userGroupId}/service-organizations/${serviceOrganizationId}/payment-options/`),
    getBody: (data) => data
  }),
  getDedicatedServiceWorkers: dataEndpoint<DedicatedServiceWorkersGetApiData, DedicatedServiceWorkersGetApiResponses>({
    getUrl: ({ userGroupId, serviceOrganizationId }) =>
      apiUrl(`user-groups/${userGroupId}/service-organizations/${serviceOrganizationId}/dedicated-service-workers/`)
  }),
  patchDedicatedServiceWorkers: responseEndpoint<
    DedicatedServiceWorkersPatchApiData,
    DedicatedServiceWorkersPatchApiResponses
  >({
    getUrl: ({ userGroupId, serviceOrganizationId }) =>
      apiUrl(`user-groups/${userGroupId}/service-organizations/${serviceOrganizationId}/dedicated-service-workers/`),
    getBody: ({ userGroupId: _, serviceOrganizationId: __, ...body }) => body
  })
};
